import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';

async function bootstrap() {
  if ((document as any).prerendering) {
    await new Promise<void>(resolve => {
      document.addEventListener('prerenderingchange', () => resolve(), { once: true });
    });
  }

  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
}

bootstrap();
